import { render, staticRenderFns } from "./TheTable.vue?vue&type=template&id=35aa32c2&"
import script from "./TheTable.vue?vue&type=script&lang=js&"
export * from "./TheTable.vue?vue&type=script&lang=js&"
import style0 from "./TheTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports